import Icon, {
  CustomIconComponentProps,
} from '@ant-design/icons/lib/components/Icon';
import React from 'react';

const SvgDefaults = {
  focusable: false,
  viewBox: '0 0 102.4 102.4',
  fill: 'currentColor',
  width: '1em',
  height: '1em',
};
/**
 * Icone Personalizzate SVG   viewBox="0 0 102.4 102.4"
 *
 */
export const FvIconRadio = (props: Partial<CustomIconComponentProps>) => (
  <Icon
    component={() => (
      <svg {...SvgDefaults}>
        <path d="M51.2,6.4C26.46,6.4,6.4,26.46,6.4,51.2s20.06,44.8,44.8,44.8,44.8-20.06,44.8-44.8S75.94,6.4,51.2,6.4Zm0,82c-20.54,0-37.2-16.66-37.2-37.2S30.66,14,51.2,14s37.2,16.66,37.2,37.2-16.66,37.2-37.2,37.2Z" />
        <circle
          cx="51.2"
          cy="51.2"
          r="22.4"
          transform="translate(-15.7 78.91) rotate(-67.5)"
        />
      </svg>
    )}
    {...props}
  />
);
